module.exports = __webpack_public_path__ + "static/media/thompson_felliciano.c50d6c41.jpg";